/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH2Icon32Regular = forwardRef('SettingsSlidersH2Icon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 8h11.1a5.002 5.002 0 0 1 9.8 0H28a1 1 0 1 1 0 2h-3.1a5.002 5.002 0 0 1-9.8 0H4a1 1 0 0 1 0-2Zm16-2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 22a1 1 0 1 0 0 2h3.1a5.002 5.002 0 0 0 9.8 0H28a1 1 0 1 0 0-2H16.9a5.002 5.002 0 0 0-9.8 0H4Zm11 1a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z" })));
});
